<template>
	<div>
		<form>
			<div class="field">
				<input class="input" type="text" placeholder="Search">		
			</div>
			
		</form>
		

		<div v-if="data">
			<table class="table is-fullwidth is-hoverable">
				<thead>
					<tr>
						<th>
							Relation
						</th>
						<th>
							Action
						</th>
						<th>
							User
						</th>
						<th>
							Timestamp
						</th>
					</tr>
				</thead>
				<tbody>
					<router-link tag="tr" :to="`/tools/history/${item._id}`" v-for="item in data">
						<td>{{item.controller}}</td>
						<td>{{item.action}}</td>
						<td>{{item.user}}</td>
						<td>{{item.created_at}}</td>
					</router-link>
				</tbody>
			</table>	
		</div>
		<loading v-else></loading>
	</div>
</template>

<script>
	import { GET_HISTORY_DATA } from "@/store/actions";
	import Loading from "@/components/Loading";
	export default {
		name: "History",
		components: { Loading },
		computed: {
			data(){
				return this.$store.state.history.data;
			}
		},
		mounted(){
			console.log("History mounted");
			if(!this.data){
				this.getData();
			}
		},
		methods: {
			getData(){
				this.$store.dispatch(GET_HISTORY_DATA);
			}
		}
	}
</script>